const SettingsIcon = ({ size = 21, color = "#2E3192" }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      fill={color}
      d="M19.14 12.936c.04-.3.06-.612.06-.936s-.02-.636-.06-.936l2.03-1.578a.479.479 0 00.11-.612l-1.922-3.323a.48.48 0 00-.58-.22l-2.39.96a7.018 7.018 0 00-1.62-.936l-.36-2.52a.48.48 0 00-.474-.408h-3.844a.48.48 0 00-.474.408l-.36 2.52a7.018 7.018 0 00-1.62.936l-2.39-.96a.48.48 0 00-.58.22L2.72 9.87a.479.479 0 00.11.612l2.03 1.578c-.04.3-.06.612-.06.936s.02.636.06.936l-2.03 1.578a.479.479 0 00-.11.612l1.922 3.323a.48.48 0 00.58.22l2.39-.96c.498.408 1.044.75 1.62.936l.36 2.52c.04.228.238.408.474.408h3.844c.236 0 .434-.18.474-.408l.36-2.52c.576-.186 1.122-.528 1.62-.936l2.39.96c.196.078.422 0 .58-.22l1.922-3.323a.479.479 0 00-.11-.612l-2.03-1.578zM12 15.6a3.6 3.6 0 110-7.2 3.6 3.6 0 010 7.2z"
    />
  </svg>
);

export default SettingsIcon;
